import type { IPlaceholderConfig } from '~/types/template'

import BackgroundImageBlock from '~/components/DynamicScreen/Blocks/BackgroundImage'
import CloseButtonBlock from '~/components/DynamicScreen/Blocks/CloseButton'
import IconBlock from '~/components/DynamicScreen/Blocks/Icon'
import TextBlock from '~/components/DynamicScreen/Blocks/Text'
import TitleBlock from '~/components/DynamicScreen/Blocks/Title'
import { EmptyBlock } from '~/components/DynamicScreen/utils'

export const page4CommonBlocks = (
  <>
    <CloseButtonBlock />
  </>
)

export const page4PickerCommonBlocks = (
  <>
    <CloseButtonBlock />
    <div className="picker-shape static" />
  </>
)

export const page4CommonPlaceholders: IPlaceholderConfig[] = [
  {
    category: 'mandatory mentions',
    className: 'restore-text',
    component: TextBlock,
    defaultValue: {
      color: '#2E2F31',
      translation: 'already_purchased_restore',
    },
    deviceType: 'ios',
    hiddenFields: ['translation'],
    placeholderKey: 'restore_txt_4',
    type: ['color', 'translation'],
  },
  {
    category: 'mandatory mentions',
    className: 'cancel-text',
    component: TextBlock,
    defaultValue: {
      color: '#2E2F31',
      translation: 'onboarding_slide_purchasing_renewable',
    },
    hiddenFields: ['translation'],
    placeholderKey: 'txt_cancel_mention_4',
    type: ['color', 'translation'],
  },
  {
    category: 'mandatory mentions',
    className: 'tos-text',
    component: TextBlock,
    defaultValue: {
      color: '#959595',
      translation: 'terms_conditions',
    },
    hiddenFields: ['translation'],
    placeholderKey: 'tos_txt_4',
    type: ['color', 'translation'],
  },
  {
    category: 'mandatory mentions',
    component: EmptyBlock,
    placeholderKey: 'action_open_tos_4',
    type: ['action'],
  },
  {
    category: 'arguments',
    component: TitleBlock,
    defaultValue: { color: '#2E2F31' },
    placeholderKey: 'title_txt_4',
    previewProperties: {
      text: 'Marketing argument Paywall',
    },
    type: ['color', 'translation'],
  },
  {
    category: 'arguments',
    className: 'list-image thick',
    component: IconBlock,
    defaultValue: { color: '#2871FF' },
    placeholderKey: 'list_img_4_1',
    type: ['color'],
  },
  {
    category: 'arguments',
    className: 'list-image thick',
    component: IconBlock,
    defaultValue: { color: '#2871FF' },
    placeholderKey: 'list_img_4_2',
    type: ['color'],
  },
  {
    category: 'arguments',
    className: 'list-image thick',
    component: IconBlock,
    defaultValue: { color: '#2871FF' },
    placeholderKey: 'list_img_4_3',
    type: ['color'],
  },
  {
    category: 'arguments',
    className: 'list-image thick',
    component: IconBlock,
    defaultValue: { color: '#2871FF' },
    placeholderKey: 'list_img_4_4',
    type: ['color'],
  },
  {
    category: 'arguments',
    className: 'list-text',
    component: TextBlock,
    defaultValue: { color: '#2E2F31' },
    placeholderKey: 'list_txt_4_1',
    previewProperties: {
      text: 'First premium argument paywall',
    },
    type: ['color', 'translation'],
  },
  {
    category: 'arguments',
    className: 'list-text',
    component: TextBlock,
    defaultValue: { color: '#2E2F31' },
    placeholderKey: 'list_txt_4_2',
    previewProperties: {
      text: 'Second premium argument paywall',
    },
    type: ['color', 'translation'],
  },
  {
    category: 'arguments',
    className: 'list-text',
    component: TextBlock,
    defaultValue: { color: '#2E2F31' },
    placeholderKey: 'list_txt_4_3',
    previewProperties: {
      text: 'Third premium argument paywall',
    },
    type: ['color', 'translation'],
  },
  {
    category: 'arguments',
    className: 'list-text',
    component: TextBlock,
    defaultValue: { color: '#2E2F31' },
    placeholderKey: 'list_txt_4_4',
    previewProperties: {
      text: 'Fourth premium argument paywall',
    },
    type: ['color', 'translation'],
  },
]

export const page4PickerCommonPlaceholders: IPlaceholderConfig[] = [
  {
    category: 'background',
    component: BackgroundImageBlock,
    placeholderKey: 'background_img_4',
    type: 'asset',
  },
  {
    category: 'arguments',
    component: TitleBlock,
    defaultValue: { color: '#2E2F31' },
    placeholderKey: 'title_txt_4',
    previewProperties: { text: `Marketing argument Paywall in two lines maximum` }, //text par défault
    type: ['translation', 'color'],
  },
  {
    category: 'arguments',
    className: 'list-text',
    component: TextBlock,
    defaultValue: { color: '#2E2F31' },
    placeholderKey: 'list_txt_4_1',
    previewProperties: { text: `First premium argument paywall` }, //text par défault
    type: ['translation', 'color'],
  },
  {
    category: 'arguments',
    className: 'list-text',
    component: TextBlock,
    defaultValue: { color: '#2E2F31' },
    placeholderKey: 'list_txt_4_2',
    previewProperties: { text: `Second premium argument paywall` },
    type: ['translation', 'color'],
  },
  {
    category: 'arguments',
    className: 'list-text',
    component: TextBlock,
    defaultValue: { color: '#2E2F31' },
    placeholderKey: 'list_txt_4_3',
    previewProperties: { text: `Third premium argument paywall` },
    type: ['translation', 'color'],
  },
  {
    category: 'arguments',
    className: 'list-image thick',
    component: IconBlock,
    defaultValue: { color: '#0073FF' },
    placeholderKey: 'list_img_4_1',
    type: ['color'],
  },
  {
    category: 'arguments',
    className: 'list-image thick',
    component: IconBlock,
    defaultValue: { color: '#0073FF' },
    placeholderKey: 'list_img_4_2',
    type: ['color'],
  },
  {
    category: 'arguments',
    className: 'list-image thick',
    component: IconBlock,
    defaultValue: { color: '#0073FF' },
    placeholderKey: 'list_img_4_3',
    type: ['color'],
  },
  {
    category: 'mandatory mentions',
    className: 'cancel-text',
    component: TextBlock,
    defaultValue: {
      color: '#2E2F31',
      translation: 'onboarding_slide_purchasing_renewable', //to be discussed to keep trad key by default
    },
    hiddenFields: ['translation'],
    placeholderKey: 'txt_cancel_mention_4',
    type: ['color', 'translation'],
  },
  {
    category: 'mandatory mentions',
    className: 'restore-text',
    component: TextBlock,
    defaultValue: {
      color: '#2E2F31',
      translation: 'already_purchased_restore',
    },
    deviceType: 'ios',
    hiddenFields: ['translation'],
    placeholderKey: 'restore_txt_4',
    type: ['color', 'translation'],
  },
  {
    category: 'mandatory mentions',
    className: 'tos-text',
    component: TextBlock,
    defaultValue: {
      color: '#959595',
      translation: 'terms_conditions',
    },
    hiddenFields: ['translation'],
    placeholderKey: 'tos_txt_4',
    type: ['color', 'translation'],
  },
  {
    category: 'mandatory mentions',
    component: EmptyBlock,
    placeholderKey: 'action_open_tos_4',
    type: ['action'],
  },
  {
    category: 'picker',
    component: TextBlock,
    defaultValue: { color: '#2E2F31' },
    iapKey: 'iap_1',
    placeholderKey: 'price_txt_month_4a',
    previewProperties: { text: `$3,33/month` },
    type: ['translation', 'color'],
  },
  {
    category: 'picker',
    component: TextBlock,
    defaultValue: { color: '#1A1A1A' },
    iapKey: 'iap_1',
    placeholderKey: 'price_txt_4a',
    previewProperties: { text: `$39,99` },
    type: ['translation', 'color'],
  },
  {
    category: 'picker',
    component: TextBlock,
    defaultValue: { color: '#1A1A1A' },
    iapKey: 'iap_2',
    placeholderKey: 'price_txt_4b',
    previewProperties: { text: `9,99$` },
    type: ['translation', 'color'],
  },
  {
    category: 'picker',
    component: TextBlock,
    defaultValue: { color: '#1A1A1A' },
    placeholderKey: 'duration_text_4b',
    previewProperties: { text: `1 month` },
    type: ['translation', 'color'],
  },
  {
    category: 'picker',
    component: TextBlock,
    defaultValue: {
      color: '#1A1A1A',
    },
    filters: ['eligible'],
    placeholderKey: 'duration_text_4a_1',
    previewProperties: {
      text: '12 months',
    },
    type: ['translation', 'color'],
  },
  {
    category: 'in-app',
    component: EmptyBlock,
    placeholderKey: 'iap_1',
    type: 'iap',
  },
  {
    category: 'in-app',
    component: EmptyBlock,
    placeholderKey: 'iap_2',
    type: 'iap',
  },
  {
    category: 'picker',
    component: TextBlock,
    defaultValue: {
      color: '#1A1A1A',
    },
    filters: ['not_eligible'],
    placeholderKey: 'duration_text_4a_2',
    previewProperties: {
      text: '12 months',
    },
    type: ['translation', 'color'],
  },
]
